import { useTranslation } from 'react-i18next'
import { fmt } from './format'

/** VH-222: monthly series and the earliest mover (time order, not cause). */
export default function TimelineSection({ timeline }) {
  const { t } = useTranslation()
  if (!timeline) return null
  if (!timeline.available) {
    return (
      <section className="space-y-2" data-testid="timeline">
        <h3 className="text-base font-semibold">{t('systemView.timeline.title')}</h3>
        <p className="text-sm text-gray-600" data-testid="timeline-unavailable">
          {t('systemView.timeline.unavailable', { months: timeline.months, min: timeline.min_months })}
        </p>
      </section>
    )
  }
  const series = timeline.series || {}
  const months = [...new Set(Object.values(series).flatMap((rows) => rows.map((r) => r.month)))].sort()
  const movers = new Map((timeline.movers || []).map((m) => [m.variable, m]))
  const earliest = timeline.earliest_mover
  return (
    <section className="space-y-2" data-testid="timeline">
      <h3 className="text-base font-semibold">{t('systemView.timeline.title')}</h3>
      {earliest ? (
        <div className="border border-blue-300 bg-blue-50 rounded-lg p-3 text-sm" data-testid="earliest-mover">
          <p>{t('systemView.timeline.earliest', { variable: t(`systemView.variables.${earliest.variable}`), month: earliest.month })}</p>
          {earliest.same_month?.length > 0 && (
            <p className="text-xs">{t('systemView.timeline.sameMonth', { variables: earliest.same_month.map((v) => t(`systemView.variables.${v}`)).join(', ') })}</p>
          )}
          <p className="text-xs text-gray-600 mt-1">{t('systemView.timeline.orderNote')}</p>
        </div>
      ) : (
        <p className="text-sm text-gray-600">{t('systemView.timeline.noMover')}</p>
      )}
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs">
          <thead>
            <tr className="text-left text-gray-600">
              <th className="py-1 pr-3">{t('systemView.timeline.variable')}</th>
              {months.map((m) => <th key={m} className="py-1 pr-3">{m}</th>)}
            </tr>
          </thead>
          <tbody>
            {Object.entries(series).map(([name, rows]) => {
              const byMonth = Object.fromEntries(rows.map((r) => [r.month, r.value]))
              const mover = movers.get(name)
              return (
                <tr key={name} className="border-t">
                  <td className="py-1 pr-3">{t(`systemView.variables.${name}`)}</td>
                  {months.map((m) => (
                    <td key={m} className={`py-1 pr-3 ${mover?.month === m ? 'font-semibold text-primary' : ''}`}
                      data-testid={mover?.month === m ? `mover-${name}` : undefined}>
                      {fmt(byMonth[m], 0)}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </section>
  )
}
